import Index from '../../pages/mitu/order/index';
import Pc from '../../pages/mitu/order/pc';


const base = 'order';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/mitu/order.js